export const NAV = {
  brand: 'nav-brand',
  linkBenefits: 'nav-link-benefits',
  linkIngredients: 'nav-link-ingredients',
  linkWaitlist: 'nav-link-waitlist',
};

export const HERO = {
  section: 'hero-section',
  title: 'hero-title',
  subtitle: 'hero-subtitle',
  ctaPrimary: 'hero-cta-primary',
  ctaSecondary: 'hero-cta-secondary',
  bottleImage: 'hero-bottle-image',
  badge: 'hero-prelaunch-badge',
};

export const PROBLEM = {
  section: 'problem-section',
  title: 'problem-title',
  body: 'problem-body',
};

export const HOW_IT_WORKS = {
  section: 'how-it-works-section',
  title: 'how-it-works-title',
  body: 'how-it-works-body',
  image: 'how-it-works-image',
};

export const BENEFITS = {
  section: 'benefits-section',
  card1: 'benefit-card-1',
  card2: 'benefit-card-2',
  card3: 'benefit-card-3',
};

export const RESULT = {
  section: 'result-section',
  image: 'result-image',
  caption: 'result-caption',
};

export const LOOKBOOK = {
  section: 'lookbook-section',
  title: 'lookbook-title',
  intro: 'lookbook-intro',
  item: (i) => `lookbook-item-${i}`,
  image: (i) => `lookbook-image-${i}`,
  caption: (i) => `lookbook-caption-${i}`,
};

export const INGREDIENTS = {
  section: 'ingredients-section',
  title: 'ingredients-title',
  list: 'ingredients-list',
};

export const WAITLIST = {
  section: 'waitlist-section',
  form: 'waitlist-form',
  inputFirstName: 'waitlist-input-first-name',
  inputEmail: 'waitlist-input-email',
  submit: 'waitlist-submit',
  success: 'waitlist-success',
  error: 'waitlist-error',
  count: 'waitlist-count',
  referralBlock: 'waitlist-referral-block',
  referralLink: 'waitlist-referral-link',
  referralCopy: 'waitlist-referral-copy',
  referralCount: 'waitlist-referral-count',
  referralWhatsapp: 'waitlist-referral-whatsapp',
  referralInstagram: 'waitlist-referral-instagram',
  referralBadge: 'waitlist-referral-badge',
};

export const FOOTER = {
  section: 'footer-section',
  tagline: 'footer-tagline',
};
